module.exports = __webpack_public_path__ + "img/mob_home_01.f61c96bd.png";